<template>

    <div class="attachment-list">

        <div v-for="(att, index) in attachmentsForGroup" :key="index">
            <b-card no-body>
                <b-card-body>
                    <b-row>
                        <b-col cols="6">
                            {{ att.name }}
                        </b-col>
                        <b-col cols="6" class="text-right">
                            <b-btn size="sm" class="mr-2 btn-icon btn-ghost-blue"
                                   v-if="!readOnly"
                                   @click="remove(att)">
                                <shs-icon name="trash"></shs-icon>
                            </b-btn>
                            <b-btn size="sm" class="mr-2 btn-icon btn-ghost-blue"
                                   @click="download(att, true)">
                                <shs-icon name="magnifying-glass"></shs-icon>
                            </b-btn>
                            <b-btn size="sm" class="btn-icon btn-ghost-blue"
                                   @click="download(att, false)">
                                <shs-icon name="data-transfer-download"></shs-icon>
                            </b-btn>
                            <div class="mt-2"
                                 v-if="!att.file_exists">
                                <b-badge variant="danger">
                                    {{ $i18n.gt('BADGE_FILE_NOT_FOUND') }}
                                </b-badge>
                            </div>
                        </b-col>
                    </b-row>
                </b-card-body>
            </b-card>
        </div>
        <b-row class="my-3"
               v-if="!readOnly">
            <b-col class="text-right">
                <file-upload
                    class="btn btn-sm btn-primary btn-icon btn-ghost-blue"
                    :input-id="group"
                    :post-action="postAction"
                    extensions="pdf"
                    accept="accept"
                    :headers="{Authorization: $store.state.currentUser.auth_key}"
                    :multiple="false"
                    :size="1024 * 1024 * 10"
                    v-model="files"
                    @input-file="inputFile"
                    ref="upload">
                    <shs-icon name="plus"></shs-icon>
                </file-upload>
            </b-col>
        </b-row>

    </div>

</template>

<script>

/**
 * Component to list attachments for a model, and allow uploading or removing attachments.
 */

import FileUpload from 'vue-upload-component'
import * as _ from 'lodash'

export default {
    name: 'AttachmentList',
    components: {
        FileUpload
    },
    props: {
        // NB: we could probably compute one of modelClass/modelTable from the other,
        // but it's complicated, so let's just be explicit...
        modelClass: String, // unqualified PHP class name of model (used in g_attachment table)
        modelTable: String, // PHP controller path for model (used in api requests)
        modelId: Number,
        group: String,
        extensions: String, // allowable file extensions - e.g. "pdf, jpg"
        accept: String,     // accepted content types - e.g. "application/pdf, image/jpeg"
        readOnly: Boolean
    },
    data() {
        return {
            modelInstance: Object,
            files: []
        }
    },
    computed: {
        attachmentsForGroup() {
            return _.filter(this.modelInstance.attachments, (att) => att.group == this.group)
        },
        postAction() {
            return this.$api.getAttachmentUploadUrl(this.modelClass, this.modelId, this.group)
        }
    },
    methods: {
        download(att, preview) {
            this.$api.downloadAttachment(att, preview)
                .catch((e) => {
                    this.$utils.handleError(e, 'Could not download file')
                })
        },
        async remove(att) {
            if (await this.$bvModal.msgBoxConfirm('Delete attached file?')) {
                try {
                    await this.$api.deleteItem(this, 'attachment', att)
                    this.refresh()
                } catch (e) {
                    this.$utils.handleError(e, 'Could not remove file')
                }
            }
        },
        inputFile(newFile, oldFile) {
            // when a file is selected, auto-start upload
            if (newFile && !oldFile) {
                this.$refs.upload.active = true
            }
        },
        refresh() {
            // reload the parent model and its attachment list
            this.$api.getItem(this, this.modelTable, this.modelId)
                .then((item) => {
                    this.modelInstance = item
                })
        }
    },
    mounted() {
        this.refresh()

        // refresh after a file is uploaded
        this.$watch(
            () => {
                return (this.readOnly ? null : this.$refs.upload.uploaded)
            },
            (val) => {
                if (val) {
                    this.refresh()
                }
            }
        )
    },

}
</script>


